import { useContext, useEffect, useState } from "react";
import "./NamedLicenses.css";
import WidgetContainer from "../../UiLib/WidgetContainer/WidgetContainer";
import { Context } from "../../..";
import { isAxiosError } from "axios";
import { AppContext } from "../../../App";
import PersonLineDisplay from "../../Shared/PersonLineDisplay";
import { fullNameFormat } from "../../../helpers/Inicials";
import ArrowUp from "../../../assets/ArrowUpBlue.svg";
import Plus from "../../../assets/plus_blue.svg";
import Trash from "../../../assets/deleteElementBlue.svg";
import ContainerWithOverlay from "../../UiLib/ContainerWithOverlay/ContainerWithOverlay";
import SelectDropdown from "../../Shared/SelectDropdown/SelectDropdown";
import UserPopupWrapper from "../../Shared/UserPopup/UserPopupWrapper";
import Avatar, { AvatarSize } from "../../Shared/Avatar/Avatar";
import { ILicenseViewModule, ILicenseViewVersion } from "../../../common/api_interfaces/license/ILicenseView";
import { IGetNamedLicenses } from "../../../common/api_interfaces/license/IGetNamedLicenses";
import { IGetAllUsers } from "../../../common/api_interfaces/user/IGetAllUsers";
import { IFullUserInfo } from "../../../common/api_interfaces/user/IUserInfo";
import { UserStatusCode } from "../../../common/enums/userStatus";

const NamedLicenses = () => {
    const [licenses, setLicenses] = useState<IGetNamedLicenses[]>([]);
    const [licenseInfos, setLicenseInfos] = useState<ILicenseViewVersion[]>([]);
    const { store } = useContext(Context);
    const { showToast } = useContext(AppContext);
    const [users, setUsers] = useState<IFullUserInfo[]>([]);
    const [addUsersLicense, setAddUsersLicense] = useState<IGetNamedLicenses>();
    const [openLicenseCodes, setOpenLicenseCodes] = useState<string[]>([]);
    const [availableLicenses, setAvailableLicenses] = useState<string[]>([]);

    useEffect(() => {
        (async () => {
            try {
                const licensesRes = await store.licenseService.getNamedLicenses();
                setLicenses(licensesRes.data);
                const reqBody: IGetAllUsers = {
                    onlyActivated: true,
                    statuses: [UserStatusCode.Active, UserStatusCode.Invited],
                };
                const usersRes = await store.userService.getAllUsers(reqBody);
                setUsers(usersRes.data);
                const licenseInfoRes = await store.licenseService.getAllLicenses();
                setLicenseInfos(licenseInfoRes.data.filter((l) => l.status === "active"));
                setAvailableLicenses([
                    ...Object.entries(store.getAvailableModules())
                        .filter((entry) => entry[1] === true)
                        .map((e) => e[0]),
                    "activationLicense",
                ]);
            } catch (err) {
                if (isAxiosError(err)) showToast(err.response?.data.message);
            }
        })();
    }, []);

    const changeNamedUsers = async (licenseCode: string, addedUser?: IFullUserInfo, deletedUserId?: number) => {
        try {
            const license = licenses.find((l) => l.code === licenseCode);
            if (!license) return;
            await store.licenseService.addNamedLicenseUser({
                named: addedUser ? [addedUser.id!] : [],
                deleted: deletedUserId ? [deletedUserId] : [],
                code: licenseCode,
            });
            if (addedUser) license.users.push({ ...addedUser, id: addedUser.id!, statusCode: UserStatusCode.Active }); //Тут statusCode просто заглушка
            if (deletedUserId) license.users = license.users.filter((u) => u.id !== deletedUserId);
            setLicenses([...licenses]);
        } catch (err) {
            if (isAxiosError(err)) showToast(err.response?.data.message);
        }
    };

    const handlePlusButtonClick = (license: IGetNamedLicenses) => {
        setAddUsersLicense(license);
    };

    const toggleLicense = (code: string) => {
        if (openLicenseCodes.some((l) => l === code)) setOpenLicenseCodes(openLicenseCodes.filter((l) => l !== code));
        else {
            setOpenLicenseCodes([...openLicenseCodes, code]);
        }
    };

    function getCurrentDate(dateFrom?: string, dateTo?: string) {
        let _dateFrom = new Date(dateFrom ? dateFrom : "");
        let _dateTo = new Date(dateTo ? dateTo : "");

        const dateFromString = _dateFrom.toLocaleString("ru", { day: "numeric", month: "2-digit", year: "numeric" });
        const dateToString = _dateTo.toLocaleString("ru", { day: "numeric", month: "2-digit", year: "numeric" });
        return `${dateFromString}-${dateToString}`;
    }

    const getLicenseInfo = (moduleCode: string) => {
        const modules: ILicenseViewModule[] = [];
        licenseInfos.forEach((lI) => {
            modules.push(...lI.modules.filter((m) => m.code === moduleCode));
        });
        return (
            <div>
                {modules.map((module) => {
                    if (module.namedCount && module.namedCount > 0)
                        return (
                            <div>
                                <span className="named-license-dates">
                                    {getCurrentDate(module.dateFrom, module.dateTo)}:
                                </span>{" "}
                                <span className="named-license-slots">{module.namedCount}</span>
                            </div>
                        );
                })}
            </div>
        );
    };

    const getUserSelector = (license: IGetNamedLicenses) => {
        return (
            <ContainerWithOverlay
                onOverlayClick={() => {
                    setAddUsersLicense(undefined);
                }}
            >
                <WidgetContainer className="named-license-user-select">
                    <h1 className="named-license-header">
                        Добавить пользователя в <span>{license.name}</span>
                    </h1>
                    <SelectDropdown
                        optionsContainerStyle={{
                            width: "100%",
                            height: "300px",
                            overflow: "scroll",
                        }}
                        enableSearch={true}
                    >
                        <SelectDropdown.Selected>
                            <div>Пользователь</div>
                        </SelectDropdown.Selected>
                        {users
                            .filter((u) => !license.users.some((lU) => lU.id === u.id))
                            .map((user) => (
                                <SelectDropdown.Option
                                    textForSearch={user.surname + " " + user.name + " " + user.middlename}
                                >
                                    <div
                                        className="named-license-user-option"
                                        onClick={() => {
                                            changeNamedUsers(license.code, user);
                                            setAddUsersLicense(undefined);
                                        }}
                                    >
                                        <PersonLineDisplay
                                            name={fullNameFormat(user, "s N M")}
                                            userId={user.id}
                                        />
                                    </div>
                                </SelectDropdown.Option>
                            ))}
                    </SelectDropdown>
                </WidgetContainer>
            </ContainerWithOverlay>
        );
    };

    return (
        <div className="named-licenses-container">
            {addUsersLicense ? getUserSelector(addUsersLicense) : null}
            {licenses
                .filter((l) => availableLicenses.some((aL) => aL === l.code))
                .map((license) => {
                    const isOpen = openLicenseCodes.some((lC) => lC === license.code);
                    return (
                        <WidgetContainer className="named-license-container">
                            <div className="named-license-row">
                                <h1 className="named-license-header">{license.name}</h1>
                                <div style={{ display: "flex", gap: "12px" }}>
                                    {!isOpen ? (
                                        <div style={{ display: "flex" }}>
                                            {license.users.slice(0, 5).map((u) => (
                                                <Avatar
                                                    className="named-license-avatar"
                                                    userId={u.id}
                                                    size={AvatarSize.s}
                                                />
                                            ))}
                                            {license.users.length > 5 ? (
                                                <div className="named-license-avatar-number">
                                                    +{license.users.length - 5}
                                                </div>
                                            ) : null}
                                        </div>
                                    ) : null}
                                    <button className="blue-arrow-button" onClick={() => toggleLicense(license.code)}>
                                        <img
                                            src={ArrowUp}
                                            alt="arrow"
                                            style={!isOpen ? { rotate: "180deg" } : {}}
                                        ></img>
                                    </button>
                                </div>
                            </div>
                            {isOpen ? (
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "24px",
                                    }}
                                >
                                    <div className="named-license-divider"></div>
                                    <div className="named-license-row">
                                        <h1 className="named-license-header">Пользователи:</h1>
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "end",
                                                width: "80%",
                                                gap: "10px",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    display: "flex",
                                                    gap: "12px",
                                                    flexWrap: "wrap",
                                                    justifyContent: "end",
                                                }}
                                            >
                                                {license.users.map((user) => (
                                                    <div className="named-license-user">
                                                        <UserPopupWrapper userId={user.id}>
                                                            <PersonLineDisplay
                                                                textStyle={
                                                                    user.statusCode === UserStatusCode.Blocked
                                                                        ? { textDecoration: "line-through" }
                                                                        : undefined
                                                                }
                                                                name={fullNameFormat(user, "s N M")}
                                                                userId={user.id}
                                                            />
                                                        </UserPopupWrapper>
                                                        <button
                                                            className="blue-round-button"
                                                            onClick={() =>
                                                                changeNamedUsers(license.code, undefined, user.id)
                                                            }
                                                        >
                                                            <img
                                                                src={Trash}
                                                                alt="delete"
                                                                style={{
                                                                    height: "16px",
                                                                }}
                                                            />
                                                        </button>
                                                    </div>
                                                ))}
                                            </div>
                                            <button
                                                className="blue-round-button"
                                                onClick={() => {
                                                    handlePlusButtonClick(license);
                                                }}
                                            >
                                                <img src={Plus} alt="add" />
                                            </button>
                                        </div>
                                    </div>
                                    <div className="named-license-divider"></div>
                                    <div className="named-license-row">
                                        <h1 className="named-license-header">Период действия:</h1>
                                        <div>{getLicenseInfo(license.code)}</div>
                                    </div>
                                </div>
                            ) : null}
                        </WidgetContainer>
                    );
                })}
        </div>
    );
};

export default NamedLicenses;
